import React from "react";

const Footer = () => {
  const menu = [
    {
      id: 1,
      title: "Output",
      subMenu: [
        {
          id: 1,
          title: "Medium Publication",
          link: "https://medium.com/swf-lab"
        },
        {
          id: 2,
          title: "Member Articles List",
          link: "https://docs.google.com/spreadsheets/d/12usP8AKKuEwC0YeQ9pbH4MRIt6dZ2AUPjFC0QHd-CGA/edit#gid=0"
        },
        {
          id: 3,
          title: "Github",
          link: "https://github.com/SWF-Lab"
        }
      ],
    },
    {
      id: 2,
      title: "Research Project Team",
      subMenu: [
        {
          id: 1,
          title: "#1 Ethereum Scalability",
          link: "https://medium.com/swf-lab/eth-scalability/home"
        },
        {
          id: 2,
          title: "#2 Stock/Currency Analysis",
          link: "https://medium.com/swf-lab/stock-currency/home",
        },
        {
          id: 3,
          title: "#3 Liberal Radicalism",
          link: "https://medium.com/swf-lab/liberal-and-radical/home"
        },
        {
          id: 4,
          title: "#4 Cryptography & ZKP",
          link: "https://medium.com/swf-lab/cryptography-zkp/home"
        },
      ],
    },
    {
      id: 3,
      title: "Staffs",
      subMenu: [
        {
          id: 1,
          pos: "Chef",
          title: " ChiHaoLu",
          link: "https://chihaolu.me/",
        },
        {
          id: 2,
          pos: "OR",
          title: "KilliMilli",
        },
        {
          id: 3,
          pos: "PD",
          title: "TBD",
        },
        {
          id: 4,
          pos: "MPR",
          title: "TBD",
        },
      ],
    },
    {
      id: 4,
      title: "Contact",
      subMenu: [
        {
          id: 1,
          title: "LinkedIn",
          link: "https://www.linkedin.com/company/swf-lab/",
        },
        {
          id: 2,
          title: "Business E-Mail",
          link: "mailto:swflab.taiwan@gmail.com",
        },
        {
          id: 3,
          title: "New Member Application Form",
          link: "https://forms.gle/Z94UcLTEGU7GRHh28",
        },
        {
          id: 4,
          title: "Donation & Advertisment Program",
          link: "https://hackmd.io/@ChiHaoLu/swflab-business-project",
        },
      ],
    },
  ];

  return (
    <div className="border-t border-gray">
      <div className="my-28 max-w-screen-xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 text-center gap-12">
          {menu.map(({ id, title, subMenu }) => (
            <div key={id}>
              <h1 className="text-lg font-bold">{title}</h1>
              <ul className="mt-1">
                {subMenu.map(({ id, pos, title, link }) => (
                  <li key={id}>
                    <b>{pos} </b><a href={link} target="_blank">{title}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="my-16 text-center text-sm black">
          © Copyright swfLAB
          <br />Final Updated. 2022-11-05
        </p>
      </div>
    </div>
  );
};

export default Footer;
